import { Button, IconButton, Grid, Tooltip, MenuItem, Select } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import Badge from '@material-ui/core/Badge';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import DraftsIcon from '@material-ui/icons/Drafts';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import GridOnIcon from '@material-ui/icons/GridOn';
import LastPage from '@material-ui/icons/LastPage';
import MailOutlinedIcon from '@material-ui/icons/MailOutlined';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import ViewListIcon from '@material-ui/icons/ViewList';
import ReplayIcon from '@material-ui/icons/Replay';
import MaterialTable from 'material-table';
import Moment from 'moment/moment';
import QueryString from 'querystring';
import React, { forwardRef, useCallback, useEffect, useRef, useState, useMemo } from 'react';
import { Animated } from 'react-animated-css';
import { useDispatch, useSelector } from 'react-redux';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { useHistory } from 'react-router-dom';
import Url from 'url';
import join from 'url-join';
import axios from '../axios-default';
import Modal from '../components/Modal/modal';
import { ApiServerUrl } from '../config.json';
import { updateConfig } from '../store/config/config.action';
import { easySnackbar } from '../store/Noti/noti.actions';
import { getFromObj, useLang } from '../util/lang';
import '../util/object';
import { usePrevious } from '../util/react';
import '../util/string';
import '../util/array';
import style from './css/patients.module.css';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { TextField } from '@material-ui/core';
import frontend_config from '../frontend_config';
import { getWebAbsPath } from '../util/path';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import DraftPhotoViewer from '../components/DraftPhotoViewer';
import moment from 'moment/moment';
import Banner from '../components/Banner';
import SmileDesignCreateCaseButton from './SmileDesign/SmileDesignCreateCaseButton';
import { checkReleaseSmileDesignByDstri, setProductMatrixArray } from '../store/SmileDesign/SmileDesignSlice';
import NewCaseModalContent from '../components/NewCase/NewCaseContent';
import CreateButton from '../components/Button/CreateButton/CreateButton';
import CreateOrderRetainerButton from '../components/Button/CreateOrderRetainerButton';
import LoadingSpinner from '../components/Loader/LoadingSpinner';
import useAuth from '../hooks/useAuth';
import GridView from '../components/GridView/GridView';
import { usePatientsStyles } from '../style/usePatientsStyles';
import { useCreateNewCaseOptions } from '../components/NewCase/use-create-new-case-option';

const hostname = window.location.hostname;

const TableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const caseStatusList = [
    'DRAFT',
    'SUBMITTED',
    'AWAITING',
    'DEFECT_UPLOADED',
    'DEFECT_RESPONDED',
    'RECEIVED',
    'PLAN_UPLOADED',
    'CHANGE_REQUEST',
    'PLAN_APPROVED',
    'PRODUCTION',
    'DELIVERED',
    'NEXT_SET_REQUEST',
    'ALL_DELIVERED',
    'ENDED',
    'REFINEMENT',
    'DEFECT_RESUBMIT',
    'RETRACK',
    'RETRACK_END',
    'RETRACK_AWAITING',
    'RETRACK_ALL_MATERIAL_RECEIVED',
    'RETRACK_REPORT',
    'RETRACK_PRODUCTION_IN_PROGRESS',
    'RETRACK_CONTINUE',
    'RESTORATION_TOOL_FORM_SUBMITTED',
    'UPGRADE_REQUEST',
];

const notificationMsg = false;
export default function Patients(props) {
    const classes = usePatientsStyles(),
        dispatch = useDispatch(),
        history = useHistory(),
        get = useLang('Patients'),
        getGlobal = useLang('global'),
        [config, countries, lang] = useSelector((store) => [store.config.config, store.res.countries, store.lang]);

    const CanExportTableUserRoleArr = ['SADMIN', 'DISTR', 'GADMIN'];
    const [loading, setLoading] = useState(true),
        [mode, setMode] = useState(null),
        [cat, setCat] = useState(localStorage.getItem('Patients.cat') || 'ALL'),
        [searchObj, setSearchObj] = useState(JSON.parse(localStorage.getItem('Patients.searchObj')) || {}),
        [tableArchiveConfirm, settableArchiveConfirm] = useState(false),
        [tableUnarchiveConfirm, settableUnarchiveConfirm] = useState(false),
        [archiveTargetCaseId, setArchiveTargetCaseId] = useState(null),
        [unarchiveTargetCaseId, setUnarchiveTargetCaseId] = useState(null),
        [startDate, setStartDate] = useState(null),
        [endDate, setEndDate] = useState(null),
        [CaseOptionTypeArr, setCaseOptionTypeArr] = useState([]),
        [SelectCaseOptionType, setSelectCaseOptionType] = useState(null),
        [productMatrix, setProductMatrix] = useState(null);

    const [photoGalleryAvailable, setPhotoGalleryAvailable] = useState(false);
    const isReleaseSmileDesignByDistri = useSelector((state) => state.smileDesign.isReleaseSmileDesignByDistri);

    const { availableNewCaseOptions } = useCreateNewCaseOptions(productMatrix);
    const res = useSelector(({ res }) => res);
    const countrySelect = useMemo(
        () =>
            res.countries.map((c) => (
                <MenuItem value={c.country_name} key={c.country_id}>
                    {c.country_name}
                </MenuItem>
            )),
        [res?.countries]
    );
    const auth = useAuth();
    const role = useRef(auth.user.role),
        distr_group_id = useRef(JSON.parse(localStorage.getItem('distr_group_id'))),
        doctor_dist_id = JSON.parse(localStorage.getItem('doctor_dist_id')),
        columnOrder = useRef([]),
        columnHidden = useRef([]),
        columns = useRef([]),
        lastPageSize = useRef(),
        lastPageNo = useRef(0),
        tableRef = useRef(null),
        tableTopRef = useRef(null),
        gridRef = useRef(null);
    const prevCat = usePrevious(cat),
        prevMode = usePrevious(mode);
    // modal
    const [modalOpen, setModalOpen] = useState(false);
    const [draftPhotoModalOpen, setDraftPhotoModalOpen] = useState(false);

    let countryId = -1;
    try {
        countryId = parseInt(JSON.parse(localStorage.getItem('country_id')));
    } catch {
        console.error("Connot get the doctor's country");
    }

    const isMarieGroup = useMemo(() => {
        let value = JSON.parse(localStorage.getItem('isMarieGroup'));
        return value;
    }, []);

    useEffect(() => {
        async function getNewCaseOptionType() {
            const result = await axios.get(`/case/getcaseoption/${doctor_dist_id}`);
            if (result.data.case_options.length > 0) {
                setCaseOptionTypeArr(result.data.case_options);
                // for default value
                setSelectCaseOptionType(result.data.case_options[0].opt1);
            }
        }

        if (role.current === 'DR') {
            getNewCaseOptionType();
        }
    }, []);

    useEffect(() => {
        (async () => {
            try {
                if (role.current === 'DR') {
                    const {
                        data: { pm },
                    } = await axios.get(`/productmatrix/productmatrixForDr`);
                    const result = await axios.get(
                        `/productmatrix/productmatrixForDr/${isMarieGroup ? 'EU_UNDER_MARIE' : 'SMILE_DESIGN'}`
                    ); // Purpose: get product matrix for smile design

                    dispatch(
                        checkReleaseSmileDesignByDstri({
                            productMatrixList: result.data.pm,
                        })
                    );

                    dispatch(setProductMatrixArray(result.data.pm)); // Purpose: set product matrix array for smile design
                    setProductMatrix(pm);
                }
            } catch (err) {
                dispatch(easySnackbar(err.message || err, 'error'));
            }
        })();
    }, []);

    useEffect(() => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        onbeforeunload = () => {
            localStorage.removeItem('Patients.cat');
            localStorage.removeItem('Patients.searchObj');
            localStorage.removeItem('Patients.pageNo');
        };
        return () => {
            onbeforeunload = null;
        };
    }, []);

    useEffect(() => {
        columnOrder.current = getFromObj(config, 'Patients.columnOrder');
        columnHidden.current = getFromObj(config, 'Patients.columnHidden');
        columns.current = getColumns();
        if ((getFromObj(config, 'Patients.mode') || 'table') !== mode) {
            setMode(getFromObj(config, 'Patients.mode') || 'table');
        }
    }, [config]);

    useEffect(() => {
        if (prevCat !== undefined && prevCat !== cat) {
            if (mode === 'table' && tableRef.current) {
                tableRef.current.onQueryChange();
            } else if (mode === 'grid' && gridRef.current) {
                gridRef.current.onQueryChange(cat);
            }
        }
    }, [cat]);

    const formatNewCaseLink = (v, selectCaseOptionType) => {
        return selectCaseOptionType
            ? `/patients/newPatient/${v['case_type']}/${selectCaseOptionType}`
            : `/patients/newPatient/${v['case_type']}`;
    };

    const handleNewTabClickOpen = (e, data) => {
        e.stopPropagation();
        const url = data.case_status === 'DRAFT'
            ? `/patients/${data.patient_id}/${data.case_id}/edit${data.new_case_option ? `/${data.new_case_option}` : ''}`
            : `/patients/${data.case_id}`;
        const newWindow = window.open(getWebAbsPath(url), '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null;
    };

    const handlePageChange = useCallback(() => {
        tableTopRef.current.scrollIntoView({ behavior: 'smooth' });
    }, [tableTopRef.current]);

    const reloadtable = () => {
        history.push('/blank');
        history.replace(`/`);
    };

    const handleTableArchive = useCallback(
        async (e) => {
            try {
                e.stopPropagation();
                if (archiveTargetCaseId === null) {
                    throw new Error('Target case id is null');
                }
                let { archivedData } = await axios.post(`case/${archiveTargetCaseId}/archived`);
                await dispatch(easySnackbar('Case Archived', 'success'));
                setArchiveTargetCaseId(null);
                reloadtable();
            } catch (err) {
                console.error(err);
                dispatch(easySnackbar(err.message ?? err, 'error'));
            }
        },
        [archiveTargetCaseId, setArchiveTargetCaseId, dispatch]
    );

    const handleTableUnarchive = useCallback(
        async (e) => {
            try {
                e.stopPropagation();
                if (unarchiveTargetCaseId === null) {
                    throw new Error('Target case id is null');
                }
                let { unarchivedData } = await axios.post(`case/${unarchiveTargetCaseId}/archived/undo`);
                await dispatch(easySnackbar('Case Unarchived', 'success'));
                setUnarchiveTargetCaseId(null);
                reloadtable();
            } catch (err) {
                console.error(err);
                dispatch(easySnackbar(err.message ?? err, 'error'));
            }
        },
        [unarchiveTargetCaseId, setUnarchiveTargetCaseId, dispatch]
    );

    const handleClickOpen = (e, caseId) => {
        e.stopPropagation();
        settableArchiveConfirm(true);
        setArchiveTargetCaseId(caseId);
    };
    const handleClose = (e) => {
        e.stopPropagation();
        setArchiveTargetCaseId(null);
        settableArchiveConfirm(false);
    };
    const handleUnarchiveClickOpen = (e, caseId) => {
        e.stopPropagation();
        setUnarchiveTargetCaseId(caseId);
        settableUnarchiveConfirm(true);
    };
    const handleUnarchiveClose = (e) => {
        e.stopPropagation();
        setUnarchiveTargetCaseId(null);
        settableUnarchiveConfirm(false);
    };

    // new case option code

    const handleCaseOptionTypeChange = (event) => {
        setSelectCaseOptionType(event.target.value);
    };

    const getColumns = () => {
        let columns = [];
        if (role.current === 'DR' || role.current === 'NURSE') {
            columns = [
                {
                    field: 'unread_changes_count',
                    title: get('case_list.columns.actions'),
                    defaultSort: 'desc',
                    render: (data) => (
                        <>
                            {cat !== 'ARCHIVED' ? (
                                <>
                                    <IconButton onClick={(e) => handleClickOpen(e, data.case_id)}>
                                        <Tooltip
                                            title={getFromObj(lang, 'dict.pages.paitents.markarchive')}
                                            placement="top"
                                        >
                                            <ArchiveIcon style={{ color: '#212121' }}></ArchiveIcon>
                                        </Tooltip>
                                    </IconButton>
                                </>
                            ) : null}
                            {cat === 'ARCHIVED' ? (
                                <>
                                    <IconButton onClick={(e) => handleUnarchiveClickOpen(e, data.case_id)}>
                                        <Tooltip title="Unarchive" placement="top">
                                            <UnarchiveIcon style={{ color: '#212121' }}></UnarchiveIcon>
                                        </Tooltip>
                                    </IconButton>
                                </>
                            ) : null}
                            <Badge
                                style={{ marginRight: 16 }}
                                className={style.customBadge}
                                badgeContent={
                                    data.unread_status_changes_count + data.unread_chat_changes_count === 0
                                        ? null
                                        : `${data.unread_status_changes_count}+${data.unread_chat_changes_count}`
                                }
                            >
                                {data.unread_status_changes_count + data.unread_chat_changes_count === 0 ? (
                                    <IconButton disabled>
                                        <DraftsIcon />
                                    </IconButton>
                                ) : (
                                    <MailOutlinedIcon />
                                )}
                            </Badge>
                        </>
                    ),
                },
                {
                    field: 'case_status_label',
                    title: get('case_list.columns.caseStatus'),
                    cellStyle: {
                        minWidth: '130px',
                    },
                    render: (data) => (
                        <>
                            <Grid container>
                                <Grid item xs={12} className={style.verticalCenter}>
                                    {tableColumnCaseStatus(data)}
                                </Grid>
                            </Grid>
                        </>
                    ),
                },
                {
                    field: 'profile_pic',
                    title: get('case_list.columns.profile'),
                    export: false,
                    render: (data) => (
                        <img
                            alt="profile_pic"
                            style={{ width: 50, maxHeight: 75 }}
                            src={data.profile_pic + '?thumb=1'}
                            onError={(e) => {
                                let u = Url.parse(e.target.src);
                                e.target.src =
                                    u.pathname === '/' || u.pathname.startsWith('/img')
                                        ? ''
                                        : data.gender === 'M'
                                          ? getWebAbsPath('/img/maleIcon.png')
                                          : data.gender === 'F'
                                            ? getWebAbsPath('/img/femaleIcon.png')
                                            : getWebAbsPath('/img/otherIcon.png');
                            }}
                        />
                    ),
                    sorting: false,
                },
                {
                    field: 'first_name',
                    title: get(':fields.firstName'),
                },
                {
                    field: 'last_name',
                    title: get(':fields.lastName'),
                },
                {
                    field: 'gender',
                    title: get('case_list.columns.gender'),
                    lookup: {
                        M: get(':fields.male'),
                        F: get(':fields.female'),
                        O: get(':fields.other'),
                    },
                },
                {
                    field: 'patient_id',
                    // TODO: need to change the translate
                    // title: get('case_list.columns.patientID'),
                    title: 'Patient ID',
                },
                {
                    field: 'case_id',
                    // TODO: need to add the translate
                    title: 'Case ID',
                },
                {
                    field: 'doctor_created_date',
                    title: get('case_list.columns.doctor_created_date'),
                },
                {
                    field: 'created_date',
                    title: get('case_list.columns.created_date'),
                },
                {
                    field: 'updated_date',
                    title: get('case_list.columns.updated_date'),
                },
                {
                    field: 'case_type_label',
                    title: get('case_list.columns.treatmentOption'),
                },
                {
                    field: 'isSmileDesign',
                    title: get('case_list.columns.smile_design_case'),
                },
                {
                    field: 'smileDesignType',
                    title: get('case_list.columns.smile_design_type'),
                },
                {
                    field: 'approval_date',
                    title: get('case_list.columns.approvalDate'),
                },
                {
                    field: 'expiration_date',
                    title: get('case_list.columns.treatmentEndDate'),
                },
                {
                    field: 'age',
                    title: get('case_list.columns.age'),
                },
                {
                    field: 'submission_date',
                    title: get('case_list.columns.submissionDate'),
                },
                {
                    field: 'remarks',
                    title: get('case_list.columns.remarks'),
                    cellStyle: {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: 60,
                    },
                },
            ];
        } else {
            columns = [
                {
                    field: 'unread_changes_count',
                    title: get('case_list.columns.notification'),
                    defaultSort: 'desc',
                    render: (data) => (
                        <>
                            {cat !== 'ARCHIVED' ? (
                                <>
                                    <IconButton onClick={(e) => handleClickOpen(e, data.case_id)}>
                                        <Tooltip
                                            title={getFromObj(lang, 'dict.pages.paitents.markarchive')}
                                            placement="top"
                                        >
                                            <ArchiveIcon style={{ color: '#212121' }}></ArchiveIcon>
                                        </Tooltip>
                                    </IconButton>
                                </>
                            ) : null}
                            {cat === 'ARCHIVED' ? (
                                <>
                                    <IconButton onClick={(e) => handleUnarchiveClickOpen(e, data.case_id)}>
                                        <Tooltip title="Unarchive" placement="top">
                                            <UnarchiveIcon style={{ color: '#212121' }}></UnarchiveIcon>
                                        </Tooltip>
                                    </IconButton>
                                </>
                            ) : null}
                            <Badge
                                style={{ marginRight: 16 }}
                                className={style.customBadge}
                                badgeContent={
                                    data.unread_status_changes_count +
                                        data.unread_chat_changes_count +
                                        (data.unread_private_chat_changes_count || 0) +
                                        (data.unread_intl_chat_changes_count || 0) ===
                                    0
                                        ? null
                                        : `${data.unread_status_changes_count}+${data.unread_chat_changes_count}+${typeof data.unread_private_chat_changes_count === 'number' ? data.unread_private_chat_changes_count : 0}${typeof data.unread_intl_chat_changes_count === 'number' ? '+' + data.unread_intl_chat_changes_count : ''}`
                                }
                            >
                                {data.unread_status_changes_count +
                                    data.unread_chat_changes_count +
                                    (data.unread_private_chat_changes_count || 0) +
                                    (data.unread_intl_chat_changes_count || 0) ===
                                0 ? (
                                    <IconButton disabled>
                                        <DraftsIcon />
                                    </IconButton>
                                ) : (
                                    <MailOutlinedIcon />
                                )}
                            </Badge>
                        </>
                    ),
                },
                {
                    field: 'case_status_label',
                    title: get('case_list.columns.caseStatus'),
                    cellStyle: {
                        minWidth: '130px',
                    },
                    render: (data) => (
                        <>
                            <Grid container>
                                <Grid item xs={12} className={style.verticalCenter}>
                                    {tableColumnCaseStatus(data)}
                                </Grid>
                            </Grid>
                        </>
                    ),
                },
                {
                    field: 'profile_pic',
                    title: get('case_list.columns.profile'),
                    export: false,
                    render: (data) => (
                        <img
                            alt="gender"
                            style={{ width: 50 }}
                            src={data.profile_pic + '?thumb=1'}
                            onError={(e) => {
                                let u = Url.parse(e.target.src);
                                e.target.src =
                                    u.pathname === '/' || u.pathname.startsWith('/img')
                                        ? ''
                                        : data.gender === 'M'
                                          ? getWebAbsPath('/img/maleIcon.png')
                                          : data.gender === 'F'
                                            ? getWebAbsPath('/img/femaleIcon.png')
                                            : getWebAbsPath('/img/otherIcon.png');
                            }}
                        />
                    ),
                    sorting: false,
                },
                {
                    field: 'first_name',
                    title: get(':fields.firstName'),
                },
                {
                    field: 'last_name',
                    title: get(':fields.lastName'),
                },
                {
                    field: 'patient_id',
                    // TODO: need to change the translate
                    // title: get('case_list.columns.patientID'),
                    title: 'Patient ID',
                },
                {
                    field: 'case_id',
                    // TODO: need to add the translate
                    // title: get('case_list.columns.patientID'),
                    title: 'Case ID',
                },
                {
                    field: 'doctor_id',
                    title: get('case_list.columns.doctorId'),
                },
                {
                    field: 'doctor_created_date',
                    title: get('case_list.columns.doctor_created_date'),
                },
                {
                    field: 'created_date',
                    title: get('case_list.columns.created_date'),
                },
                {
                    field: 'updated_date',
                    title: get('case_list.columns.updated_date'),
                },
                {
                    field: 'case_type_label',
                    title: get('case_list.columns.treatmentOption'),
                },
                {
                    field: 'isSmileDesign',
                    title: get('case_list.columns.smile_design_case'),
                },
                {
                    field: 'smileDesignType',
                    title: get('case_list.columns.smile_design_type'),
                },
                {
                    field: 'ref_code',
                    title: get('case_list.columns.refCode'),
                },
                {
                    field: 'client_code',
                    title: get('case_list.columns.clientCode'),
                },
                {
                    field: 'approval_date',
                    title: get('case_list.columns.approvalDate'),
                },
                {
                    field: 'expiration_date',
                    title: get('case_list.columns.treatmentEndDate'),
                },
                {
                    field: 'country_name',
                    title: get(':fields.country'),
                },
                ...(!['GADMIN', 'CADMIN'].includes(role.current)
                    ? [
                          {
                              field: 'distr_name',
                              title: get('case_list.columns.distributor'),
                          },
                      ]
                    : []),
                ...(role.current !== 'CADMIN'
                    ? [
                          {
                              field: 'clinic_name',
                              title: get('case_list.columns.clinic'),
                          },
                      ]
                    : []),
                {
                    field: 'doctor_name',
                    title: get('case_list.columns.drName'),
                },
                {
                    field: 'submission_date',
                    title: get('case_list.columns.submissionDate'),
                },
                {
                    field: 'remarks',
                    title: get('case_list.columns.remarks'),
                    cellStyle: {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: 60,
                    },
                },
            ];
        }
        if (config) {
            if (Array.isArray(columnOrder.current)) {
                const orderDict = columnOrder.current.reduce((a, field, i) => {
                    if (String.isNotBlank(field)) {
                        a[field] = i;
                    }
                    return a;
                }, {});
                columns.sort((a, b) => orderDict[a.field] - orderDict[b.field]);
            }
            if (Array.isArray(columnHidden.current)) {
                const hiddenDict = columnHidden.current.reduce((a, field) => Object.assign(a, { [field]: true }), {});
                columns = columns.map((c) => Object.assign(c, { hidden: hiddenDict[c.field] }));
            }
        }

        return columns;
    };
    const saveMode = async (mode) => {
        const userId = JSON.parse(localStorage.getItem('auth-token'));
        console.log('userId', userId);
        try {
            if (userId && getFromObj(config, 'Patients.mode') !== mode) {
                await dispatch(
                    updateConfig(
                        {
                            Patients: {
                                mode,
                            },
                        },
                        userId
                    )
                );
            }
        } catch (err) {
            console.trace(err);
            dispatch(easySnackbar(err.message || err, 'error'));
        } finally {
            setMode(mode);
        }
    };
    const saveColumnOrder = async (srcIndex, destIndex) => {
        const columnsCopy = columns.current;
        const [removed] = columnsCopy.splice(srcIndex, 1);
        columnsCopy.splice(destIndex, 0, removed);
        columnOrder.current = columnsCopy.map((c) => c.field);
        const userId = JSON.parse(localStorage.getItem('auth-token'));
        if (userId) {
            try {
                await updateConfig(
                    {
                        Patients: {
                            columnOrder: columnOrder.current,
                        },
                    },
                    userId
                );
            } catch (err) {
                dispatch(easySnackbar(err.message || err, 'error'));
            } finally {
                columns.current = getColumns();
            }
        } else {
            dispatch(easySnackbar('User id invalid', 'error'));
        }
    };
    const saveColumnHidden = async (column, hidden) => {
        const userId = JSON.parse(localStorage.getItem('auth-token'));
        if (userId) {
            try {
                if (config) {
                    if (Array.isArray(columnHidden.current)) {
                        columnHidden.current = hidden
                            ? columnHidden.current.concat(column.field)
                            : columnHidden.current.filter((v) => v !== column.field);
                        if (!columnHidden.current.length) {
                            columnHidden.current = null;
                        }
                        await updateConfig(
                            {
                                Patients: {
                                    columnHidden: columnHidden.current,
                                },
                            },
                            userId
                        );
                        return;
                    }
                }
                if (hidden) {
                    await updateConfig(
                        {
                            Patients: {
                                columnHidden: [column.field],
                            },
                        },
                        userId
                    );
                }
            } catch (err) {
                console.trace(err);
                dispatch(easySnackbar(err.message || err, 'error'));
            } finally {
                columns.current = getColumns();
            }
        }
    };
    const onSearchChange = async (sObj) => {
        if (mode === 'table') {
            if (tableRef.current) tableRef.current.onSearchChangeDebounce(sObj);
        } else if (mode === 'grid') {
            if (gridRef.current) gridRef.current.onSearchChangeDebounce(sObj);
        }
    };
    const handleStart = async (date) => {
        setStartDate(Moment(date).format('YYYY-MM-DD'));
        const newSearchObj = { ...searchObj, startDate: Moment(date).format('YYYY-MM-DD') };

        setSearchObj(newSearchObj);

        if (Moment(date).isValid()) {
            localStorage.setItem('Patients.searchObj', JSON.stringify(newSearchObj));
        } else {
            localStorage.removeItem('Patients.searchObj');
        }
        onSearchChange(newSearchObj);
    };
    const handleEnd = async (date) => {
        setEndDate(Moment(date).format('YYYY-MM-DD'));
        const newSearchObj = { ...searchObj, endDate: Moment(date).format('YYYY-MM-DD') };

        setSearchObj(newSearchObj);

        if (Moment(date).isValid()) {
            localStorage.setItem('Patients.searchObj', JSON.stringify(newSearchObj));
        } else {
            localStorage.removeItem('Patients.searchObj');
        }
        onSearchChange(newSearchObj);
    };
    const handleSearch = async (update) => {
        const newSearchObj = { ...searchObj, ...update };

        setSearchObj(newSearchObj);
        if (Object.values(update).some((v) => String.isNotBlank(v))) {
            localStorage.setItem('Patients.searchObj', JSON.stringify(newSearchObj));
        } else {
            localStorage.removeItem('Patients.searchObj');
        }
        onSearchChange(newSearchObj);
    };

    const clearFilters = () => {
        if (!Object.keys(searchObj).length == 0) {
            setSearchObj({});
            setStartDate(null);
            setEndDate(null);
            localStorage.removeItem('Patients.searchObj');
            onSearchChange({});
        }
    };

    const dataGetter = async (query) => {
        let { pageSize, page: pageNo, search, orderBy, orderDirection } = query;
        let {
            searchStr,
            firstName,
            lastName,
            drName,
            patientId,
            caseId,
            caseStatus,
            country,
            startDate,
            endDate,
            caseRefCode,
            clientCode,
        } = search ?? {};
        try {
            if (orderBy && orderBy.field.endsWith('_label')) {
                orderBy.field = orderBy.field.slice(0, -6);
            }
            if (
                lastPageNo.current === 0 &&
                localStorage.getItem('Patients.pageNo') &&
                parseInt(localStorage.getItem('Patients.pageNo')) !== lastPageNo.current
            ) {
                pageNo = parseInt(localStorage.getItem('Patients.pageNo'));
            } else if (prevCat !== undefined && prevCat !== cat && cat !== localStorage.getItem('Patients.cat')) {
                pageNo = 0;
            }
            const { data } = await axios.get(
                `case?${QueryString.encode({
                    searchStr: typeof searchStr !== 'string' || String.isBlank(searchStr) ? undefined : searchStr,
                    firstName: typeof firstName !== 'string' || String.isBlank(firstName) ? undefined : firstName,
                    lastName: typeof lastName !== 'string' || String.isBlank(lastName) ? undefined : lastName,
                    drName: typeof drName !== 'string' || String.isBlank(drName) ? undefined : drName,
                    patientId: typeof patientId !== 'string' || String.isBlank(patientId) ? undefined : patientId,
                    caseId: typeof caseId !== 'string' || String.isBlank(caseId) ? undefined : caseId,
                    caseStatus: typeof caseStatus !== 'string' || String.isBlank(caseStatus) ? undefined : caseStatus,
                    country: typeof country !== 'string' || String.isBlank(country) ? undefined : country,
                    caseRefCode:
                        typeof caseRefCode !== 'string' || String.isBlank(caseRefCode) ? undefined : caseRefCode,
                    clientCode: typeof clientCode !== 'string' || String.isBlank(clientCode) ? undefined : clientCode,
                    startDate: startDate,
                    endDate: endDate,
                    sortBy: orderBy && orderBy.field,
                    sortDir: orderDirection,
                    statusFilter: cat,
                    pageSize,
                    pageNo,
                })}`
            );
            lastPageSize.current = pageSize;
            lastPageNo.current = pageNo;
            localStorage.setItem('Patients.pageNo', pageNo);
            localStorage.setItem('Patients.cat', cat);

            setPhotoGalleryAvailable(data.photo_gallery_available);

            if (loading) setLoading(false);

            return {
                data: data.case
                    .filter((c) => c.case_id >= 1)
                    .map((c) => {
                        const birthYear = c.date_of_birth && c.date_of_birth.match(/[0-9]{1,2}-[0-9]{1,2}-([0-9]{4})/);
                        let case_type_label = c.product_name === '' ? c.default_product_name : c.product_name 
                        if (case_type_label === 'Simple Smile Design') {
                            case_type_label = get(`:caseType.SIMPLE_SMILE_DESIGN`) 
                        }

                        return {
                            ...c,
                            unread_changes_count: `${c.unread_status_changes_count}+${c.unread_chat_changes_count}+${typeof c.unread_private_chat_changes_count === 'number' ? c.unread_private_chat_changes_count : 0}+${typeof c.unread_intl_chat_changes_count === 'number' ? c.unread_intl_chat_changes_count : 0}`,
                            profile_pic: c.profile_pic
                                ? join(ApiServerUrl, c.profile_pic)
                                : c.gender === 'M'
                                  ? getWebAbsPath('/img/maleIcon.png')
                                  : c.gender === 'F'
                                    ? getWebAbsPath('/img/femaleIcon.png')
                                    : getWebAbsPath('/img/otherIcon.png'),
                            case_status_label:
                                c.case_status.toUpperCase() === 'RETRACK_END'
                                    ? get(`:caseStatus.RETRACK_${c.status_param1}`)
                                    : get(`:caseStatus.${c.case_status}`),
                            case_type_label,
                            client_code: c.client_code ? c.client_code : 'N/A',
                            ref_code: c.ref_code ? c.ref_code : 'N/A',
                            created_date: c.created_date ? Moment(c.created_date).format('DD MMM YYYY') : 'N/A', //case created date
                            updated_date: c.updated_date ? Moment(c.updated_date).format('DD MMM YYYY') : 'N/A', //case udpated date
                            doctor_created_date: c.doctor_created_date
                                ? Moment(c.doctor_created_date).format('DD MMM YYYY')
                                : 'N/A',
                            expiration_date: c.expiration_date
                                ? Moment(c.expiration_date).format('DD MMM YYYY')
                                : 'N/A',
                            approval_date: c.approval_date ? Moment(c.approval_date).format('DD MMM YYYY') : 'N/A',
                            submission_date: c.submission_date
                                ? Moment(c.submission_date).format('DD MMM YYYY')
                                : 'N/A',
                            age:
                                birthYear && birthYear.length > 1 && !isNaN(parseInt(birthYear[1]))
                                    ? Moment().get('year') - parseInt(birthYear[1])
                                    : 'N/A',
                            smileDesignType: c.smileDesignType ? get(`:caseType.${c.smileDesignType}`) : 'N/A',
                            isSmileDesign: c.isSmileDesign ? get(`:const.yes`) : get(`:const.no`),
                        };
                    }),
                page: pageNo || 0,
                totalCount: data.total || 0,
            };
        } catch (err) {
            console.error(err);
            if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                history.replace('/login');
            }
        }
    };

    const CanExportTableUserRole = (userRole) => {
        return CanExportTableUserRoleArr.includes(userRole) ? true : false;
    };

    const tableColumnCaseStatus = (data) => {
        let param1 = data.status_param1;
        let caseStatus = data.case_status;

        if (caseStatus.toUpperCase() === 'RETRACK_END') {
            if (param1 === 'CANCEL' || param1 === 'FINISH') {
                return get(`:caseStatus.RETRACK_${param1}`);
            } else {
                return get(`:caseStatus.${caseStatus}`);
            }
        } else {
            // Default case status
            return get(`:caseStatus.${caseStatus}`);
        }
    };

    return (
        <>
            <Dialog open={tableArchiveConfirm} onClose={(e) => handleClose(e)}>
                <DialogContent>
                    <DialogContentText>Do you want to Archive this case?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>No</Button>
                    <Button onClick={(e) => handleTableArchive(e)}>Yes</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={tableUnarchiveConfirm} onClose={(e) => handleUnarchiveClose(e)}>
                <DialogContent>
                    <DialogContentText>Do you want to Unarchive this case?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleUnarchiveClose}>No</Button>
                    <Button onClick={(e) => handleTableUnarchive(e)}>Yes</Button>
                </DialogActions>
            </Dialog>
            <Grid
                container
                style={{
                    padding: 16,
                    background: '#f2f2f2',
                }}
            >
                <Grid item xs={12}>
                    <Banner />
                </Grid>

                {notificationMsg && (
                    <Grid item xs={12}>
                        <Alert severity="info" style={{ backgroundColor: '#b2c6d6', marginTop: 12 }}>
                            Scheduled maintenance will take place on 11 September 2021 12:00 UTC (20:00 HKT)
                        </Alert>
                    </Grid>
                )}

                <Modal
                    className="modal"
                    modal="NewCaseModal"
                    title={get('new_trioclear_case') + ' ' + get('options')}
                    open={modalOpen}
                    handleClose={() => setModalOpen(false)}
                    modalSize="md"
                    submitButton={false}
                >
                    <NewCaseModalContent
                        productMatrix={productMatrix}
                        caseOptionTypeArr={CaseOptionTypeArr}
                        LinkToFunc={formatNewCaseLink}
                        selectCaseOptionType={SelectCaseOptionType}
                        handleCaseOptionTypeChange={handleCaseOptionTypeChange}
                    />
                </Modal>

                <Modal
                    className="modal"
                    modal="DraftPhotoModal"
                    title="Your Gallery"
                    open={draftPhotoModalOpen}
                    handleClose={() => setDraftPhotoModalOpen(false)}
                    modalSize="lg"
                    submitButton={false}
                    handleCaseOptionTypeChange={handleCaseOptionTypeChange}
                >
                    <DraftPhotoViewer />
                </Modal>

                {['DR', 'NR'].includes(role.current) && (
                    <Grid xs={12} style={{ marginTop: 8 }}>
                        <Grid container alignItems="center" spacing={4}>
                            <Grid item>
                                <CreateButton
                                    name={get('new_trioclear_case')}
                                    onClick={() => {
                                        if (availableNewCaseOptions.length === 1) {
                                            history.push(
                                                formatNewCaseLink(availableNewCaseOptions[0], SelectCaseOptionType)
                                            );
                                        } else {
                                            setModalOpen(true);
                                        }
                                    }}
                                />
                            </Grid>

                            {productMatrix?.find((v) => v.case_type === 'RETAINER') && (
                                <Grid item>
                                    <CreateOrderRetainerButton />
                                </Grid>
                            )}

                            {isReleaseSmileDesignByDistri && (
                                <Grid item>
                                    <SmileDesignCreateCaseButton />
                                </Grid>
                            )}

                            {['DR', 'NR'].includes(role.current) && photoGalleryAvailable && (
                                <Grid item>
                                    <CreateButton
                                        name={get('trioclearAppPhotoGallery')}
                                        onClick={() => setDraftPhotoModalOpen(true)}
                                        icon="/img/createCase/createCaseIcon/button_icon4.png"
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                )}
                {/* <hr style={{ borderTop: "solid #dbdbdb 1px" }} /> */}

                <Grid item xs={12} style={{ marginTop: 24, marginBottom: 20 }}>
                    <div className="SearchConatiner">
                        <input
                            type="text"
                            value={searchObj.searchStr ?? ''}
                            onChange={({ target: { value } }) => handleSearch({ searchStr: value })}
                            placeholder={get('case_list.searchPlaceHolder')}
                            style={{
                                width: 'calc(100% - 4px)',
                                fontSize: 17,
                                border: 'solid 1px rgba(89,54,135,1)',
                                height: 32,
                                paddingLeft: '0px 0px 0px 4px',
                            }}
                            disabled={loading}
                        />
                    </div>
                </Grid>

                <Grid container spacing={24}>
                    <Grid item xs={12} sm={2} style={{ marginBottom: 5 }}>
                        <input
                            type="text"
                            value={searchObj.patientId ?? ''}
                            onChange={({ target: { value } }) => handleSearch({ patientId: value })}
                            placeholder="Patient ID" //{get(':fields.firstName')}
                            style={{
                                width: '95%',
                                height: 32,
                                fontSize: '17px',
                                border: 'solid 1px rgba(89,54,135,1)',
                                padding: '0px 4px',
                            }}
                            disabled={loading}
                        />
                    </Grid>

                    <Grid item xs={12} sm={2} style={{ marginBottom: 5 }}>
                        <input
                            type="text"
                            value={searchObj.firstName ?? ''}
                            onChange={({ target: { value } }) => handleSearch({ firstName: value })}
                            placeholder={get(':fields.firstName')}
                            style={{
                                width: '95%',
                                height: 32,
                                fontSize: '17px',
                                border: 'solid 1px rgba(89,54,135,1)',
                                padding: '0px 4px',
                            }}
                            disabled={loading}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <div className={classes.firstLastName}>
                            <input
                                type="text"
                                value={searchObj.lastName ?? ''}
                                onChange={({ target: { value } }) => handleSearch({ lastName: value })}
                                placeholder={get(':fields.lastName')}
                                style={{
                                    width: '95%',
                                    height: 32,
                                    fontSize: '17px',
                                    border: 'solid 1px rgba(89,54,135,1)',
                                    padding: '0px 4px',
                                }}
                                disabled={loading}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <div className={classes.firstLastName}>
                            <input
                                type="text"
                                value={searchObj.drName ?? ''}
                                onChange={({ target: { value } }) => handleSearch({ drName: value })}
                                placeholder={get(':fields.doctorName')}
                                style={{
                                    width: '95%',
                                    height: 32,
                                    fontSize: '17px',
                                    border: 'solid 1px rgba(89,54,135,1)',
                                    padding: '0px 4px',
                                }}
                                disabled={loading}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={2} style={{ marginBottom: 5 }}>
                        <input
                            type="text"
                            value={searchObj.clientCode ?? ''}
                            onChange={({ target: { value } }) => handleSearch({ clientCode: value })}
                            placeholder={get('case_list.columns.clientCode')} //{get(':fields.firstName')}
                            style={{
                                width: '95%',
                                height: 32,
                                fontSize: '17px',
                                border: 'solid 1px rgba(89,54,135,1)',
                                padding: '0px 4px',
                            }}
                            disabled={loading}
                        />
                    </Grid>
                    {role.current !== 'DR' && (
                        <Grid item xs={12} sm={2} style={{ marginBottom: 5 }}>
                            <input
                                type="text"
                                value={searchObj.caseRefCode ?? ''}
                                onChange={({ target: { value } }) => handleSearch({ caseRefCode: value })}
                                placeholder={get('case_list.columns.refCode')}
                                style={{
                                    width: '95%',
                                    height: 32,
                                    fontSize: '17px',
                                    border: 'solid 1px rgba(89,54,135,1)',
                                    padding: '0px 4px',
                                }}
                                disabled={loading}
                            />
                        </Grid>
                    )}
                    <Grid item xs={12} sm={3} style={{ marginBottom: 5 }}>
                        <p>{get('case_list.submission_date_from')}</p>

                        <div style={{ padding: 8 }}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    fullWidth
                                    maxDate={Moment().add(1, 'month').toDate()}
                                    views={['year', 'month', 'date']}
                                    value={startDate}
                                    onChange={handleStart}
                                    format="yyyy-MM-dd"
                                    placeholder={get('case_list.submission_start_date')}
                                    okLabel={<span style={{ color: '#304257' }}>Ok</span>}
                                    cancelLabel={<span style={{ color: '#304257' }}>Cancel</span>}
                                    disabled={loading}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={3} style={{ marginBottom: 5 }}>
                        <p>{get('case_list.submission_date_to')}</p>
                        <div style={{ padding: 8 }}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DatePicker
                                    fullWidth
                                    maxDate={Moment().add(1, 'month').toDate()}
                                    views={['year', 'month', 'date']}
                                    value={endDate}
                                    onChange={handleEnd}
                                    format="yyyy-MM-dd"
                                    placeholder={get('case_list.submission_end_date')}
                                    okLabel={<span style={{ color: '#304257' }}>Ok</span>}
                                    cancelLabel={<span style={{ color: '#304257' }}>Cancel</span>}
                                    disabled={loading}
                                />
                            </MuiPickersUtilsProvider>
                        </div>
                    </Grid>

                    <Grid item xs={12} sm={2} style={{ marginBottom: 5 }}>
                        <p>{get('case_list.columns.caseStatus')}&nbsp;</p>
                        <div style={{ padding: 8 }}>
                            <Select
                                displayEmpty
                                value={searchObj.caseStatus ?? ''}
                                label="CaseStatus"
                                onChange={({ target: { value } }) => handleSearch({ caseStatus: value })}
                                disabled={loading}
                            >
                                {caseStatusList.map((c) => (
                                    <MenuItem value={c}>{get(`:caseStatus.${c}`)}</MenuItem>
                                ))}
                            </Select>
                        </div>
                    </Grid>

                    {!['DR'].includes(role.current) && (
                        <Grid item xs={12} sm={2} style={{ marginBottom: 5 }}>
                            <p>{get(':fields.country')}&nbsp;</p>
                            <div style={{ padding: 8 }}>
                                <Select
                                    displayEmpty
                                    value={searchObj.country ?? ''}
                                    label="Country"
                                    onChange={({ target: { value } }) => handleSearch({ country: value })}
                                    disabled={loading}
                                >
                                    {countrySelect}
                                </Select>
                            </div>
                        </Grid>
                    )}

                    <Grid item xs={12} sm={2} style={{ marginBottom: 5 }}>
                        <p>{getGlobal('fields.caseId')}&nbsp;</p>
                        <div style={{ padding: 8 }}>
                            <TextField
                                variant="standard"
                                type="text"
                                value={searchObj.caseId ?? ''}
                                onChange={({ target: { value } }) => handleSearch({ caseId: value })}
                                placeholder={getGlobal('fields.caseId')}
                                disabled={loading}
                            />
                        </div>
                    </Grid>

                    <Grid item xs={12} sm={1}>
                        <p>&nbsp;</p>
                        {/* <IconButton style={{ height: "fit-content" }} onClick={() => this.handleClickOpen()}> */}
                        <IconButton style={{ margin: '-7px 12px' }} onClick={() => clearFilters()}>
                            <Tooltip title="Clear all filters" placement="top">
                                <ReplayIcon style={{ color: frontend_config?.[hostname]?.main_color_2 }}></ReplayIcon>
                            </Tooltip>
                        </IconButton>
                    </Grid>
                </Grid>

                <Grid container>
                    <Grid item xs={12} sm={8} style={{ marginTop: 8 }} className={style.actionNavBar}>
                        <Button
                            className={cat === 'ALL' ? classes.roundBtnActive : classes.roundBtn}
                            onClick={() => setCat('ALL')}
                        >
                            {get(':const.all')}
                        </Button>

                        <Button
                            className={cat === 'UNREAD_CASELOG' ? classes.roundBtnActive : classes.roundBtn}
                            onClick={() => setCat('UNREAD_CASELOG')}
                        >
                            {get('categories.caseLogUnreadMessage')}
                        </Button>
                        <Button
                            className={cat === 'UNREAD_CHATROOM' ? classes.roundBtnActive : classes.roundBtn}
                            onClick={() => setCat('UNREAD_CHATROOM')}
                        >
                            {get('categories.chatroomUnreadMessage')}
                        </Button>
                        <Button
                            className={cat === 'PENDING' ? classes.roundBtnActive : classes.roundBtn}
                            onClick={() => setCat('PENDING')}
                        >
                            {get('categories.pending')}
                        </Button>

                        <Button
                            className={cat === 'SUBMITTED' ? classes.roundBtnActive : classes.roundBtn}
                            onClick={() => setCat('SUBMITTED')}
                        >
                            {get('categories.inProgress')}
                        </Button>

                        <Button
                            className={cat === 'FINISHED' ? classes.roundBtnActive : classes.roundBtn}
                            onClick={() => setCat('FINISHED')}
                        >
                            {get('categories.completed')}
                        </Button>
                        <Button
                            className={cat === 'EXPIRED' ? classes.roundBtnActive : classes.roundBtn}
                            onClick={() => setCat('EXPIRED')}
                        >
                            {get('categories.expired')}
                        </Button>
                        <Button
                            className={cat === 'ARCHIVED' ? classes.roundBtnActive : classes.roundBtn}
                            onClick={() => setCat('ARCHIVED')}
                        >
                            {get('categories.archived')}
                        </Button>
                    </Grid>

                    <Grid item xs={12} sm={4} style={{ marginTop: 8, textAlign: 'right' }}>
                        <Button
                            className={mode === 'grid' ? classes.activeView : ''}
                            style={{
                                marginTop: 8,
                            }}
                            onClick={() => saveMode('grid')}
                        >
                            <GridOnIcon />
                        </Button>
                        <Button
                            className={mode === 'table' ? classes.activeView : ''}
                            style={{
                                marginTop: 8,
                            }}
                            onClick={() => saveMode('table')}
                        >
                            <ViewListIcon />
                        </Button>
                    </Grid>
                </Grid>
            </Grid>

            <Grid
                container
                style={{
                    padding: 16,
                    background: '#f2f2f252',
                    minHeight: 680,
                }}
            >
                {loading && (
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <LoadingSpinner />
                    </div>
                )}
                <Animated animationIn="fadeIn" isVisible={!loading} animateOnMount={false} style={{ width: '100%' }}>
                    <Grid item xs={12}>
                        {mode === 'table' && (
                            <>
                                <div ref={tableTopRef} />
                                <MaterialTable
                                    title={
                                        role.current === 'DR' ? (
                                            <>
                                                <p style={{ fontSize: 12, fontWeight: 700, margin: '2px 0px' }}>
                                                    <span
                                                        style={{
                                                            borderLeft: '6px solid #ff6161',
                                                            paddingLeft: 6,
                                                        }}
                                                    >
                                                        {get('notification.caseRow')}
                                                    </span>
                                                    : {get('notification.waitingForYourAction')}
                                                </p>
                                                <p style={{ fontSize: 12, fontWeight: 700, margin: '2px 0px' }}>
                                                    <span
                                                        style={{
                                                            borderLeft: '6px solid #ffb961',
                                                            paddingLeft: 6,
                                                        }}
                                                    >
                                                        {get('notification.caseRow')}
                                                    </span>
                                                    : {get('notification.treatmentInProgress')}
                                                </p>
                                                <p style={{ fontSize: 12, fontWeight: 700, margin: '2px 0px' }}>
                                                    {get('notification.notification')}:
                                                    <span
                                                        style={{
                                                            padding: '2px 8px',
                                                            backgroundColor: 'red',
                                                            color: 'white',
                                                            borderRadius: 20,
                                                        }}
                                                    >
                                                        {get('notification.statusUpdate')} +{' '}
                                                        {get('notification.unreadMsg')}
                                                    </span>
                                                </p>
                                            </>
                                        ) : role.current === 'ADMIN' || role.current === 'SADMIN' ? (
                                            <>
                                                <p style={{ fontSize: 12, fontWeight: 700, margin: '2px 0px' }}>
                                                    <span
                                                        style={{
                                                            borderLeft: '6px solid #ff6161',
                                                            paddingLeft: 6,
                                                        }}
                                                    >
                                                        {get('notification.caseRow')}
                                                    </span>
                                                    : {get('notification.waitingForYourAction')}
                                                </p>
                                                <p style={{ fontSize: 12, fontWeight: 700, margin: '2px 0px' }}>
                                                    <span
                                                        style={{
                                                            borderLeft: '6px solid #ffb961',
                                                            paddingLeft: 6,
                                                        }}
                                                    >
                                                        {get('notification.caseRow')}
                                                    </span>
                                                    : {get('notification.treatmentInProgress')}
                                                </p>
                                                <p style={{ fontSize: 12, fontWeight: 700, margin: '2px 0px' }}>
                                                    {get('notification.notification')}:
                                                    <span
                                                        style={{
                                                            padding: '2px 8px',
                                                            backgroundColor: 'red',
                                                            color: 'white',
                                                            borderRadius: 20,
                                                        }}
                                                    >
                                                        {get('notification.statusUpdate')} +{' '}
                                                        {get('notification.unreadMsg')} +{' '}
                                                        {get('notification.unreadPrivateMsg')} +{' '}
                                                        {get('notification.unreadTSandCSMsg')}
                                                    </span>
                                                </p>
                                            </>
                                        ) : (
                                            <>
                                                <p style={{ fontSize: 12, fontWeight: 700, margin: '2px 0px' }}>
                                                    <span
                                                        style={{
                                                            borderLeft: '6px solid #ff6161',
                                                            paddingLeft: 6,
                                                        }}
                                                    >
                                                        {get('notification.caseRow')}
                                                    </span>
                                                    : {get('notification.waitingForYourAction')}
                                                </p>
                                                <p style={{ fontSize: 12, fontWeight: 700, margin: '2px 0px' }}>
                                                    <span
                                                        style={{
                                                            borderLeft: '6px solid #ffb961',
                                                            paddingLeft: 6,
                                                        }}
                                                    >
                                                        {get('notification.caseRow')}
                                                    </span>
                                                    : {get('notification.treatmentInProgress')}
                                                </p>
                                                <p style={{ fontSize: 12, fontWeight: 700, margin: '2px 0px' }}>
                                                    {get('notification.notification')}:
                                                    <span
                                                        style={{
                                                            padding: '2px 8px',
                                                            backgroundColor: 'red',
                                                            color: 'white',
                                                            borderRadius: 20,
                                                        }}
                                                    >
                                                        {get('notification.statusUpdate')} +{' '}
                                                        {get('notification.unreadMsg')} +{' '}
                                                        {get('notification.unreadPrivateMsg')}
                                                    </span>
                                                </p>
                                            </>
                                        )
                                    }
                                    tableRef={tableRef}
                                    columns={getColumns()}
                                    data={dataGetter}
                                    icons={TableIcons}
                                    onColumnDragged={saveColumnOrder}
                                    onChangeColumnHidden={saveColumnHidden}
                                    onChangePage={handlePageChange}
                                    onRowClick={(_, data) => {
                                        handleNewTabClickOpen(_, data);
                                    }}
                                    options={{
                                        rowStyle: (data) => ({
                                            borderLeft: ['DRAFT', 'AWAITING', 'PLAN_UPLOADED'].includes(
                                                data.case_status.toUpperCase()
                                            )
                                                ? 'solid 12px #ff6161'
                                                : data.case_status.toUpperCase() === 'ENDED'
                                                  ? 'solid 12px grey'
                                                  : 'solid 12px #ffb961',
                                        }),
                                        initialPage: 0,
                                        searchText: searchObj,
                                        emptyRowsWhenPaging: false,
                                        exportButton: CanExportTableUserRole(role.current) && {
                                            csv: CanExportTableUserRole(role.current),
                                            pdf: false,
                                        },
                                        exportFileName: `export_case_file_${moment().format('YYYY-MM-DD_HH_mm_ss')}`,
                                        exportAllData: true,
                                        debounceInterval: 700,
                                        columnsButton: true,
                                        pageSize: 10,
                                        searchFieldStyle: {
                                            display: 'none',
                                        },
                                        pageSizeOptions: [10, 15, 30, 50, 100],
                                        minBodyHeight: 700,
                                        // maxBodyHeight: 1000,
                                    }}
                                />
                            </>
                        )}
                        {mode === 'grid' && (
                            <Grid container>
                                <GridView searchStr={searchObj} data={dataGetter} ref={gridRef} />
                            </Grid>
                        )}
                    </Grid>
                </Animated>
            </Grid>
        </>
    );
}
